import { logWrapper } from '../utils';

export default [
  'runtimeConstant',
  '$stateProvider',
  function (runtimeConstant, $stateProvider) {
    function run() {
      try {
        $stateProvider
          .state('modules.forms', {
            url: '/cadastros',
            templateUrl: 'views/modules/cadastros.html',
            controller: 'formsController',
          })
          .state('modules.forms.contracts', {
            url: '/contratos',
            templateUrl: 'views/modules/list.html',
            controller: 'crudController',
            data: {
              title: 'Contratos',
              states: {
                create: 'modules.forms.contracts-new',
                edit: 'modules.forms.contracts-edit',
                list: 'modules.forms.contracts',
              },
              permissions: {
                only: ['ManageCompanies'],
                redirectTo: 'home.list',
              },
            },
            resolve: {
              service: 'contractCrudService',
            },
          })
          .state('modules.forms.contracts-new', {
            url: '/contratos/novo',
            templateUrl: 'views/modules/forms/contracts/new.html',
            controller: 'crudController',
            data: {
              title: 'Contratos',
              crudTitle: 'NEW CONTRACT',
              states: {
                create: false,
                edit: false,
                list: 'modules.forms.contracts',
              },
              permissions: {
                only: ['ManageCompanies'],
                redirectTo: 'home.list',
              },
            },
            resolve: {
              service: 'contractCrudService',
            },
          })
          .state('modules.forms.contracts-edit', {
            url: '/contratos/edit/:id',
            templateUrl: 'views/modules/forms/contracts/new.html',
            controller: 'crudController',
            data: {
              title: 'Contratos',
              crudTitle: 'EDIT CONTRACT',
              states: {
                create: false,
                edit: false,
                list: 'modules.forms.contracts',
              },
              permissions: {
                only: ['ManageCompanies'],
                redirectTo: 'home.list',
              },
            },
            resolve: {
              service: 'contractCrudService',
            },
          })
          .state('modules.forms.companies', {
            url: '/empresas',
            templateUrl: 'views/modules/list.html',
            controller: 'crudController',
            data: {
              title: 'Empresas',
              states: {
                create: 'modules.forms.companies-new',
                edit: 'modules.forms.companies-edit',
                list: 'modules.forms.companies',
              },
              permissions: {
                only: ['ManageCompanies'],
                redirectTo: 'home.list',
              },
            },
            resolve: {
              service: 'companyCrudService',
            },
          })
          .state('modules.forms.companies-new', {
            url: '/empresas/novo',
            templateUrl: 'views/modules/forms/companies/new.html',
            controller: 'crudController',
            data: {
              title: 'Empresas',
              crudTitle: 'NEW COMPANY',
              states: {
                create: false,
                edit: false,
                list: 'modules.forms.companies',
              },
              permissions: {
                only: ['ManageCompanies'],
                redirectTo: 'home.list',
              },
            },
            resolve: {
              service: 'companyCrudService',
            },
          })
          .state('modules.forms.companies-edit', {
            url: '/empresas/editar/:id',
            templateUrl: 'views/modules/forms/companies/new.html',
            controller: 'crudController',
            data: {
              title: 'Empresas',
              crudTitle: 'EDIT COMPANY',
              states: {
                create: false,
                edit: false,
                list: 'modules.forms.companies',
              },
              permissions: {
                only: ['ManageCompanies'],
                redirectTo: 'home.list',
              },
            },
            resolve: {
              service: 'companyCrudService',
            },
          })
          .state('modules.forms.repositories', {
            url: '/repositorios',
            templateUrl: 'views/modules/list.html',
            controller: 'crudController',
            data: {
              title: 'Repositorios',
              states: {
                create: 'modules.forms.repositories-new',
                edit: 'modules.forms.repositories-edit',
                list: 'modules.forms.repositories',
              },
              permissions: {
                only: ['ADMIN', 'ManageRepositories'],
                redirectTo: 'home.list',
              },
            },
            resolve: {
              service: 'repositoryCrudService',
            },
          })
          .state('modules.forms.repositories-new', {
            url: '/repositorios/novo',
            templateUrl: 'views/modules/forms/repositories/new.html',
            controller: 'crudController',
            data: {
              title: 'Repositorios',
              crudTitle: 'NEW REPOSITORY',
              states: {
                create: false,
                edit: false,
                list: 'modules.forms.repositories',
              },
              permissions: {
                only: ['ADMIN', 'ManageRepositories'],
                redirectTo: 'home.list',
              },
            },
            resolve: {
              service: 'repositoryCrudService',
            },
          })
          .state('modules.forms.repositories-edit', {
            url: '/repositorios/editar/:id?tab',
            templateUrl: 'views/modules/forms/repositories/new.html',
            controller: 'crudController',
            data: {
              title: 'Repositorios',
              crudTitle: 'EDIT REPOSITORY',
              states: {
                create: false,
                edit: false,
                list: 'modules.forms.repositories',
              },
              permissions: {
                only: ['ADMIN', 'ManageRepositories'],
                redirectTo: 'home.list',
              },
            },
            resolve: {
              service: 'repositoryCrudService',
            },
          })
          .state('modules.forms.documentTypes', {
            url: '/tipos-de-documentos',
            templateUrl: 'views/modules/list.html',
            controller: 'crudController',
            data: {
              title: 'Tipos de documentos',
              states: {
                create: 'modules.forms.documentTypes-new',
                edit: 'modules.forms.documentTypes-edit',
                list: 'modules.forms.documentTypes',
              },
              permissions: {
                only: ['ADMIN', 'ManageDocumentTypes'],
                redirectTo: 'home.list',
              },
            },
            resolve: {
              service: 'documentTypeCrudService',
            },
          })
          .state('modules.forms.documentTypes-new', {
            url: '/tipos-de-documentos/novo',
            templateUrl: 'views/modules/forms/documentTypes/new.html',
            controller: 'crudController',
            data: {
              title: 'Tipos de documentos',
              crudTitle: 'NEW DOCUMENT TYPE',
              states: {
                create: false,
                edit: false,
                list: 'modules.forms.documentTypes',
              },
              permissions: {
                only: ['ADMIN', 'ManageDocumentTypes'],
                redirectTo: 'home.list',
              },
            },
            resolve: {
              service: 'documentTypeCrudService',
            },
          })
          .state('modules.forms.documentTypes-edit', {
            url: '/tipos-de-documentos/editar/:id?tab',
            templateUrl: 'views/modules/forms/documentTypes/new.html',
            controller: 'crudController',
            data: {
              title: 'Tipos de documentos',
              crudTitle: 'EDIT DOCUMENT TYPE',
              states: {
                create: false,
                edit: false,
                list: 'modules.forms.documentTypes',
              },
              permissions: {
                only: ['ADMIN', 'ManageDocumentTypes'],
                redirectTo: 'home.list',
              },
            },
            resolve: {
              service: 'documentTypeCrudService',
            },
          })
          .state('modules.forms.additionalFields', {
            url: '/campos-adicionais',
            templateUrl: 'views/modules/list.html',
            controller: 'crudController',
            data: {
              title: 'ADDITIONAL FIELDS',
              states: {
                create: 'modules.forms.additionalFields-new',
                edit: 'modules.forms.additionalFields-edit',
                list: 'modules.forms.additionalFields',
              },
              permissions: {
                only: ['ADMIN', 'ManageAdditionalFields'],
                redirectTo: 'home.list',
              },
            },
            resolve: {
              service: 'additionalFieldCrudService',
            },
          })
          .state('modules.forms.additionalFields-new', {
            url: '/campos-adicionais/novo',
            templateUrl: 'views/modules/forms/additionalFields/new.html',
            controller: 'crudController',
            data: {
              title: 'ADDITIONAL FIELDS',
              crudTitle: 'NEW ADDITIONAL FIELD',
              states: {
                create: false,
                edit: false,
                list: 'modules.forms.additionalFields',
              },
              permissions: {
                only: ['ADMIN', 'ManageAdditionalFields'],
                redirectTo: 'home.list',
              },
            },
            resolve: {
              service: 'additionalFieldCrudService',
            },
          })
          .state('modules.forms.additionalFields-edit', {
            url: '/campos-adicionais/editar/:id?tab',
            templateUrl: 'views/modules/forms/additionalFields/new.html',
            controller: 'crudController',
            data: {
              title: 'ADDITIONAL FIELDS',
              crudTitle: 'EDIT ADDITIONAL FIELD',
              states: {
                create: false,
                edit: false,
                list: 'modules.forms.additionalFields',
              },
              permissions: {
                only: ['ADMIN', 'ManageAdditionalFields'],
                redirectTo: 'home.list',
              },
            },
            resolve: {
              service: 'additionalFieldCrudService',
            },
          })

          .state('modules.forms.lists', {
            url: '/listas',
            templateUrl: 'views/modules/list.html',
            controller: 'crudController',
            data: {
              title: 'Listas',
              states: {
                create: 'modules.forms.lists-new',
                edit: 'modules.forms.lists-edit',
                list: 'modules.forms.lists',
              },
              permissions: {
                only: ['ADMIN', 'ManageDataLists'],
                redirectTo: 'home.list',
              },
            },
            resolve: {
              service: 'listCrudService',
            },
          })
          .state('modules.forms.lists-new', {
            url: '/listas/novo',
            templateUrl: 'views/modules/forms/lists/new.html',
            controller: 'crudController',
            data: {
              title: 'LISTS',
              crudTitle: 'NEW LIST',
              states: {
                create: false,
                edit: false,
                list: 'modules.forms.lists',
              },
              permissions: {
                only: ['ADMIN', 'ManageDataLists'],
                redirectTo: 'home.list',
              },
            },
            resolve: {
              service: 'listCrudService',
            },
          })
          .state('modules.forms.lists-edit', {
            url: '/listas/editar/:id?tab',
            templateUrl: 'views/modules/forms/lists/new.html',
            controller: 'crudController',
            data: {
              title: 'LISTS',
              crudTitle: 'EDIT LIST',
              states: {
                create: false,
                edit: false,
                list: 'modules.forms.lists',
              },
              permissions: {
                only: ['ADMIN', 'ManageDataLists'],
                redirectTo: 'home.list',
              },
            },
            resolve: {
              service: 'listCrudService',
            },
          })
          .state('modules.forms.systemConfiguration', {
            url: '/config-sistema',
            templateUrl: 'views/modules/forms/system-config.html',
            controller: 'systemConfigurationController',
            data: {
              title: 'SYSTEM CONFIGURATION',
            },
          })
          .state('modules.forms.personalization', {
            url: '/personalizacao',
            templateUrl: 'views/modules/forms/personalization/new.html',
            controller: 'personalizationController',
            data: {
              title: 'PERSONALIZATION',
            },
          })
          .state('modules.forms.digitalizacoes', {
            url: '/digitalizacoes',
            templateUrl: 'views/modules/digitalization/digitalizacoes.html',
            controller: 'digitalizationLinkController',
            data: {
              title: 'DIGITALIZATION LING',
              permissions: {
                only: ['ADMIN'],
                redirectTo: 'home.list',
              },
            }
          });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    }

    // Wrap the setup function with logWrapper for debugging purposes
    logWrapper(run, runtimeConstant.isDebugConfigs)();
  },
];
